import React from 'react'
import { useHistory } from 'react-router-dom'
import { ArrowLeft as ArrowLeftIcon } from 'react-feather'
import { Box, IconButton, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import HistoryBreadcumbs from './components/HistoryBreadcumbs/HistoryBreadcumbs'

import useStyles from './styles'
import theme from 'theme'

const ContentHeader = ({
  title,
  subTitle,
  lightColor = false,
  children,
  smFull = false,
  xsFull = true,
  breakLine = true,
  goBack = false,
  historyBreadcumbs = true,
  preserveSearch = false,
  titleComponent,
  ...rest
}) => {
  const classes = useStyles()
  const history = useHistory()

  const handleGoBack = () => history.goBack()

  return (
    <Box
      pt={title && 3}
      mb={title && 4}
      className={clsx(classes.root, {
        [classes.rootBreakpoints]: breakLine,
      })}
    >
      {titleComponent ? (
        titleComponent
      ) : (
        <Box
          className={clsx(classes.titleContainer, {
            [classes.titleContainerBreakpoints]: breakLine,
          })}
        >
          {!!historyBreadcumbs && (
            <HistoryBreadcumbs
              lightColor={lightColor}
              preserveSearch={preserveSearch}
            />
          )}
          <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
            {goBack && (
              <IconButton onClick={handleGoBack}>
                <ArrowLeftIcon
                  className={clsx(classes.icon, {
                    [classes.textLighten]: lightColor,
                  })}
                />
              </IconButton>
            )}
            <Box
              display="flex"
              flexDirection="column"
              gridGap={theme.spacing(1)}
            >
              <Typography
                className={clsx(classes.h3, {
                  [classes.textLighten]: lightColor,
                })}
                variant="h3"
                color="textPrimary"
              >
                {title}
              </Typography>
              {subTitle && (
                <Typography
                  className={clsx(classes.h3, {
                    [classes.textLighten]: lightColor,
                  })}
                  variant="h6"
                  color="textPrimary"
                >
                  {subTitle}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      )}
      {!!children && (
        <Box
          className={clsx(classes.childrenContainer, {
            [classes.childrenContainerBreakpoints]: breakLine,
          })}
          {...rest}
        >
          {children}
        </Box>
      )}
    </Box>
  )
}

ContentHeader.propTypes = {
  title: PropTypes.string,
  lightColor: PropTypes.bool,
  children: PropTypes.node,
  smFull: PropTypes.bool,
  xsFull: PropTypes.bool,
  goBack: PropTypes.bool,
  preserveSearch: PropTypes.bool,
}

export default ContentHeader
